import React from "react";

const Loading = (props) => {
    const { msg } = props;
    if(msg !== ''){
        return (
        <div class="search-loading">{msg}</div>
        );
    }
};
export default Loading;